/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import {
  CreateContactListResponseData,
  CreateContactListResponseDataFromJSON,
  CreateContactListResponseDataFromJSONTyped,
  CreateContactListResponseDataToJSON
} from './CreateContactListResponseData'

/**
 *
 * @export
 * @interface CreateContactListResponse
 */
export interface CreateContactListResponse {
  /**
   *
   * @type {number}
   * @memberof CreateContactListResponse
   */
  status?: number
  /**
   *
   * @type {CreateContactListResponseData}
   * @memberof CreateContactListResponse
   */
  data?: CreateContactListResponseData
}

export function CreateContactListResponseFromJSON(json: any): CreateContactListResponse {
  return CreateContactListResponseFromJSONTyped(json, false)
}

export function CreateContactListResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): CreateContactListResponse {
  if (json === undefined || json === null) {
    return json
  }
  return {
    status: !exists(json, 'status') ? undefined : json['status'],
    data: !exists(json, 'data') ? undefined : CreateContactListResponseDataFromJSON(json['data'])
  }
}

export function CreateContactListResponseToJSON(value?: CreateContactListResponse | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    status: value.status,
    data: CreateContactListResponseDataToJSON(value.data)
  }
}
